import { FC } from 'react'
import { Box } from '@mui/material'

interface Props {
  // 如果需要从容器组件传递props，可以在这里定义
}

export const PatientPerformancePageComponent: FC<Props> = () => {
  return (
    <div>
      <Box
        sx={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        {/* <iframe
          title="AZ Health Club PAP Membership Analytics_upload"
          width="100%"
          height="100%"
src="https://app.powerbi.com/view?r=eyJrIjoiNTYwYTRiNGItOWI1Yy00OWFmLWFmZjQtZjhkZjcwYzFjY2RhIiwidCI6Ijg0ZmIxODVkLTg0OGItNGE2YS1iMmY0LTExMzk2ODdiMWRkYSIsImMiOjEwfQ%3D%3D"
          frameBorder={0}
          allowFullScreen={true}
        /> */}
        <iframe title="AZ Health Club PAP Membership Analytics_upload-2025-08-12"   width="100%"
          height="100%"  src="https://app.powerbi.com/view?r=eyJrIjoiNjY5OTMzMjQtOTY2OS00YjdhLTg5ZTgtMTdlOWNlMTkyNzMwIiwidCI6Ijg0ZmIxODVkLTg0OGItNGE2YS1iMmY0LTExMzk2ODdiMWRkYSIsImMiOjEwfQ%3D%3D"  frameBorder={0}
          allowFullScreen={true}></iframe>
      </Box>
    </div>
  )
}